// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2q3qy","row":"ProcedureTreatmentSummary_row__2k3Am"};